/*
 *
 * File: CustomerInfoScreen.jsx
 *
 * Purpose: Customer information sreen for the user.
 *
 * Autor:   Thomas Burgard (Software development)
 * Created: 04.04.2022
 *
 * Copyright (c) DrivePartner GmbH 2022
 *
 */

import React from "react";
import { Card } from "primereact/card";
import { useTranslation } from "react-i18next";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";

/**
 * Implementation of choose offer component.
 *
 * @returns JSX-HTML-DOM
 */
const CustomerInfoScreen = (props) => {
  const userData = props.userData;
  const { t, i18n } = useTranslation("common");

  //*************************************************************/
  //* Returns JSX code                                          */
  //*************************************************************/
  return (
    <>
      {/* Insert header component */}
      <Header userData={userData} />
      <div
        className="grid p-fluid"
        style={{ paddingLeft: "20px", paddingRight: "20px", marginTop: "30px" }}
      >
        <div className="col-12 md:col-12">
          <article style={{ marginBottom: "50px" }}>
            <p>
              Please note the following customer information and our information
              on the <strong>right of withdrawal</strong>. There is no
              comprehensive storage of the contractual texts for the respective
              booking. It is therefore recommended to print out or save this
              customer information and the subsequent E-mail traffic
              independently.
            </p>
          </article>

          <article style={{ marginBottom: "50px" }}>
            <h2>I. Conclusion of contract</h2>
            <p>
              The customer can use the booking system on this website to request
              a taxi or rental car with driver for a specific time at a specific
              journey, stating the start and destination. By clicking the
              &quot;Send booking request button&quot;, the customer submits his
              binding booking request.
            </p>
            <p>
              The customer's booking request can be rejected until acceptance,
              e.g. because there are no free vehicles available. The contract is
              only concluded upon receipt of the declaration of acceptance,
              which is sent shortly after receipt of the booking request. If the
              booking request cannot be accepted, the customer will also receive
              an email notification. As usual, payment is made directly to the
              driver based on the distance actually traveled, by invoice or
              after individual contact.
            </p>
          </article>

          <article style={{ marginBottom: "50px" }}>
            <h2>II. Right of withdrawal</h2>
            <p>
              Consumers within the meaning of § 13 of the German Civil Code
              (BGB) are entitled to a statutory right of withdrawal, which must
              be clarified by law. Please note that this will only be the case
              in special individual cases that do not involve the transportation
              of people.
            </p>
            <p>
              <strong>
                According to § 312 (2) No. 5 there is no right of withdrawal for
                contracts for the transportation of people.
              </strong>
            </p>
            <p>&nbsp;</p>
            <p style={{ textAlign: "center" }}>
              <strong>
                ******************************** Right of withdrawal
                *******************************
              </strong>
            </p>
            <p>
              <strong>Right of withdrawal</strong>
            </p>
            <p>
              You have the right to cancel this contract within fourteen days
              without giving any reason. The cancellation period is fourteen
              days from the day the contract is concluded. To exercise your
              right of withdrawal, you must inform us at the address given in
              the imprint of your decision to cancel this contract by means of a
              clear statement (e.g. a letter sent by post, fax or email). You
              can use the attached sample cancellation form, but this is not
              mandatory. To meet the cancellation deadline, it is sufficient for
              you to send your communication regarding your right of
              cancellation before the cancellation period expires.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>Consequences of cancellation</strong>
            </p>
            <p>
              If you cancel this contract, we have made all payments we have
              received from you, including delivery costs (with the exception of
              the additional costs that result from the fact that you chose a
              different type of delivery than the cheapest standard delivery we
              offer have to repay immediately and at the latest within fourteen
              days from the day on which we received the notification of your
              cancellation of this contract. For this repayment, we use the same
              means of payment that you used in the original transaction, unless
              expressly agreed otherwise with you, under no circumstances will
              you be charged fees for this repayment. If you have requested that
              the services should start during the cancellation period, you have
              to pay us a reasonable amount, which is the proportion of the
              services already rendered in the service up to the point in time
              when you inform us of the exercise of the right of cancellation
              with regard to this contract Compares to the total scope of the
              services provided in the contract.
            </p>
            <p style={{ textAlign: "center" }}>
              <strong>
                ***************************** End of right of withdrawal
                ****************************
              </strong>
            </p>
          </article>

          <article style={{ marginBottom: "50px" }}>
            <p>
              The right of withdrawal does not apply to distance contracts for
              the provision of services in connection with the transportation of
              goods, the rental of motor vehicles or leisure activities if the
              contract provides for a specific date or period for the provision.
            </p>

            <p>
              In cases where there is a right of withdrawal, this legal model
              withdrawal form can be used:
            </p>
            <p>
              (If you want to cancel the contract, please fill out this form and
              send it back.)
            </p>

            <Card style={{ backgroundColor: "#fcfcfc" }}>
              <p>To: Address see legale notice</p>
              <p>
                I / we hereby cancel the contract concluded by me / us (*) for
                the purchase of the following goods (*) / the provision of the
                following service (*):
              </p>
              <p>Ordered on (*) / received on (*):</p>
              <p>Name of the consumer(s):</p>
              <p>Address of the consumer(s):</p>
              <p>
                Signature of the consumer(s) (only for notification on paper)
              </p>
              <p>Date</p>
              <p>___________________________________</p>
              <p>(*) delete inapplicable</p>
            </Card>
          </article>

          <article style={{ marginBottom: "50px" }}>
            <h2>III. Warranty and liability</h2>
            <p>The legal regulations apply.</p>
          </article>

          <article style={{ marginBottom: "50px" }}>
            <h2>III. Code of Conduct</h2>
            <p>
              There are no codes of conduct within the meaning of Art. 246a § 3
              No. 5 EGBGB.
            </p>
          </article>
        </div>
      </div>
      <Footer userData={userData} />
    </>
  );
};

export default CustomerInfoScreen;
